import * as React from "react"
import { Label, Pie, PieChart } from "recharts"
import { useQuery } from "@tanstack/react-query"
import { subHours } from "date-fns"
import { supabase } from "@/integrations/supabase/client"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  ChartLegend,
  ChartLegendContent,
} from "@/components/ui/chart"
import { Flame } from "lucide-react"

const chartConfig = {
  macros: {
    label: "Macros",
  },
  carbs: {
    label: "Carbs",
    color: "hsl(47, 96%, 53%)",
  },
  protein: {
    label: "Protein",
    color: "hsl(0, 84%, 53%)",
  },
  fat: {
    label: "Fat",
    color: "hsl(214, 84%, 53%)",
  },
} satisfies ChartConfig

interface MacroPieChartProps {
  data: Array<{
    name: string;
    value: number;
    fill: string;
  }>;
  totalCalories: number;
  atwaterTotalCalories: number;
}

export function MacroPieChart({ data, totalCalories, atwaterTotalCalories }: MacroPieChartProps) {
  return (
    <ChartContainer
      config={chartConfig}
      className="mx-auto aspect-square max-h-[250px]"
    >
      <PieChart>
        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent hideLabel />}
        />
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius={60}
          strokeWidth={5}
        >
          <Label
            content={({ viewBox }) => {
              if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                return (
                  <text
                    x={viewBox.cx}
                    y={viewBox.cy}
                    textAnchor="middle"
                    dominantBaseline="middle"
                  >
                    {/* <Flame className="inline-block h-6 w-6 mr-1" />  */}
                    <tspan
                      x={viewBox.cx}
                      y={viewBox.cy}
                      className="fill-foreground text-3xl font-bold"
                    >
                      {totalCalories}
                    </tspan>
                    <tspan
                      x={viewBox.cx}
                      y={(viewBox.cy || 0) + 24}
                      className="fill-muted-foreground"
                    >
                      calories
                    </tspan>
                    <tspan
                      x={viewBox.cx}
                      y={(viewBox.cy || 0) + 42}
                      className="fill-muted-foreground"
                    >
                      ({atwaterTotalCalories})
                    </tspan>
                  </text>
                )
              }
            }}
          />
        </Pie>
        {/* <ChartLegend
          content={<ChartLegendContent nameKey="name" />}
          className="-translate-y-2 flex-wrap gap-2 [&>*]:basis-1/3 [&>*]:justify-center"
        /> */}
      </PieChart>
    </ChartContainer>
  )
}
